import { TriangleAlert } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

interface RepresentativeFormErrorProps {
  message?: string;
}

export const RepresentativeFormError = ({ message }: RepresentativeFormErrorProps) => {
  if (!message) {
    return null;
  }

  return (
    <Alert variant="destructive">
      <TriangleAlert className="size-4" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};
